<template>
  <div class="col95 glassModulo" style="background:white;color:black;min-height: 70vh;">
    
    <div class="block tCenter" style="width:100%;">
      
      <div class="fullWidth tCenter " style="margin:0 auto;min-height: 20px;">
        
        <h2 class="fullWidth row colSm90 center subtitleSize" style="font-family: town;color:var(--orange);vertical-align: top;"  v-if="userStore.carritoCursos.length==0">
          <strong style="text-shadow: 4px 4x 14px rgba(31,38,135,0.8);">
            Registro de Encuesta del Alumno
          </strong>
        </h2>

        <!--
        <button class="btnDefault left" v-on:click="sendClose()" style="vertical-align: top;">
          <i class="bi bi-arrow-left"></i>
          <small class="hideMobile">
            Regresar
          </small>
        </button>
        -->

      </div>

      <div class="formRow col90 center" style="margin-top:10px;">

            <!--
              Nuevo Alumno
            -->
        
          <div class="formRow col95 tLeft" style="overflow-y:auto;overflow-x:hidden;max-height:75vh;">
        
            
            <section class="fullWidth center tCenter" style="margin-top:5px;">

              <div class="hideMobile" style="min-height:5vh;">
                <span></span>
              </div>

              <div class="fullWidth colSm100 tLeft" style="line-height: 18px;margin-bottom: 10px;">
                <label style="text-align:left;">
                    Contesta todas las preguntas y presiona el botón 
                    <strong>
                      "Registrar Encuesta".                  
                    </strong>
                </label>
              </div>
              

              <div class="col50 colSmMin100 row rowm">
                      
                  <strong class="formLabel ">
                    Finalidad del curso:
                  </strong>              

                  <div class="tLeft fullWidth">
                    <div>
                      <div class="col95 row colSmMin95">
                        ¿Cuál es la finalidad de tomar los cursos?
                      </div>

                    </div>
                    
                    <div>
                      <input-select-list
                      class="col75 row colSm100" 
                      :allowNew="false" 
                      :maxLength="85"
                      :minLength="4"
                      :capital="true"
                      :mode="'AN'"
                      :optionName="'tipo de finalidad'"
                      :optionsArray="listaCatalogoFinalidades"
                      :displayFieldname="'c0'"
                      :valFieldName="'c0'"
                      :ref="'finalidadRef'"
                      :placeholder="'Nombre de la finalidad'" 
                      :propName="'finalidad'"
                      :whiteBackground="false"
                      :key="formData.finalidad.key" 
                      ></input-select-list>
                      <!--
                        <button class="btnBlue col25 row" v-if="formData.finalidad.data!=''">
                          <i class="bi bi-plus col15 row left" style="font-size: 1.5rem;"></i>
                          <small class="col80 row">
                            Continuar
                          </small>
                        </button>
                      -->

                    </div>
                    
                    <!--
                      <div v-else style="min-height:20vh;">
                        <span>                        
                        </span>
                      </div>
                    -->
                  </div>
                  <!--
                    <div style="margin-top:30px;">
                      <button class="btnBlue fullWidth center">
                        <i class="bi bi-pencil-square"></i>
                        Registrar Información de Enfermedades
                      </button>
                    </div>
                  -->
                        
                
              </div>

              <div class="col50 colSmMin100 row rowm" v-if="formData.finalidad.data=='MEJORAR NEGOCIO PROPIO'">
                    
                  <strong class="formLabel">
                    Tipo de negocio:
                  </strong>

                  <div class="tLeft fullWidth">
                    <div>
                      <div class="col95 row colSmMin95">
                        En caso de contar actualmente con un negocio establecido, selecciona la opción que se adecue
                      </div>
                    </div>
                    
                    <div>
                      <input-select-list
                      class="col75 row colSm100" 
                      :allowNew="false" 
                      :maxLength="85"
                      :minLength="4"
                      :capital="true"
                      :mode="'AN'"
                      :optionName="'Tipo de Negocio'"
                      :optionsArray="listaCatalogoTipoNegocio"
                      :displayFieldname="'c0'"
                      :valFieldName="'c0'"
                      :ref="'tipoNegocioRef'"
                      :placeholder="'Tipo de Negocio'" 
                      :propName="'tipoNegocio'"
                      :whiteBackground="false" 
                      ></input-select-list>

                      ->{{formData.tipoNegocio.data}}
                      <!--
                        <button class="btnBlue col25 row" @click="addNewAlergia">
                          <i class="bi bi-plus col15 row left" style="font-size: 1.5rem;"></i>
                          <small class="col80 row">
                            Agregar
                          </small>
                        </button>
                      -->

                    </div>
                    
                    <!--
                      <div style="margin-top:30px;">
                        <button class="btnBlue fullWidth center">
                          <i class="bi bi-pencil-square"></i>
                          Registrar Información de Alergias
                        </button>
                      </div>
                      -->

                  </div>
                  
              </div>

              <div class="col50 colSmMin100 row rowm" v-if="formData.finalidad.data!=''">
    
                  <strong class="formLabel " >        
                    Satisfacción:
                  </strong>

                  <div class="tLeft fullWidth">
                    <div>
                      <div class="col95 row colSmMin95">
                        ¿Te sentiste satisfecho después de completar el curso?
                      </div>
                      <div class="col75 row colSmMin100">
                        <button :class="(formData.satisfecho.data=='S'?'btnBlue':'btnDefault')+' col30 row'" @click="formData.satisfecho.data='S';formData.satisfecho.state=1;">
                          Si
                        </button>
                        <button :class="(formData.satisfecho.data=='N'?'btnBlue':'btnDefault')+' col30 row'" @click="formData.satisfecho.data='N';formData.satisfecho.state=1;">
                          No
                        </button>
                        <button :class="(formData.satisfecho.data=='P'?'btnBlue':'btnDefault')+' col40 row'" @click="formData.satisfecho.data='P';formData.satisfecho.state=1;">
                          <small>
                            Prefiero no decir
                          </small>
                        </button>
                      </div>
                    </div>
                    
                    <!--
                      <div style="margin-top:30px;">
                        <button class="btnBlue fullWidth center">
                          <i class="bi bi-pencil-square"></i>
                          Registrar Información de Medicamentos
                        </button>
                      </div>
                      -->

                  </div>
                  
              </div>

              <div class="col50 colSmMin100 row rowm" v-if="formData.satisfecho.data!=''">
                    
                  <strong class="formLabel " >        
                    Nivel de satisfacción:
                  </strong>
                  

                  <div class="tLeft fullWidth">

                    <div>
                      <div class="col95 row colSmMin95">
                        Por favor califica el nivel de satisfacción de tu curso.
                      </div>

                      <div class="col75 row colSmMin100">
                        <button class="btnStar col20 row" @click="formData.nivelSatisfaccion.data=1;formData.nivelSatisfaccion.state=1;" @mouseenter="displayStars(1);" @mouseout="displayStars(formData.nivelSatisfaccion.data)">
                          <i class="bi bi-star" v-if="showNStars<1"></i>
                          <i class="bi bi-star-fill" v-else></i>
                        </button>
                        <button class="btnStar col20 row" @click="formData.nivelSatisfaccion.data=2;formData.nivelSatisfaccion.state=1;" @mouseenter="displayStars(2);" @mouseout="displayStars(formData.nivelSatisfaccion.data)">
                          <i class="bi bi-star" v-if="showNStars<2"></i>
                          <i class="bi bi-star-fill" v-else></i>
                        </button>
                        <button class="btnStar col20 row" @click="formData.nivelSatisfaccion.data=3;formData.nivelSatisfaccion.state=1;" @mouseenter="displayStars(3);" @mouseout="displayStars(formData.nivelSatisfaccion.data)">
                          <i class="bi bi-star" v-if="showNStars<3"></i>
                          <i class="bi bi-star-fill" v-else></i>
                        </button>
                        <button class="btnStar col20 row" @click="formData.nivelSatisfaccion.data=4;formData.nivelSatisfaccion.state=1;" @mouseenter="displayStars(4);" @mouseout="displayStars(formData.nivelSatisfaccion.data)">
                          <i class="bi bi-star" v-if="showNStars<4"></i>
                          <i class="bi bi-star-fill" v-else></i>
                        </button>
                        <button class="btnStar col20 row" @click="formData.nivelSatisfaccion.data=5;formData.nivelSatisfaccion.state=1;" @mouseenter="displayStars(5);" @mouseout="displayStars(formData.nivelSatisfaccion.data)">
                          <i class="bi bi-star" v-if="showNStars<5"></i>
                          <i class="bi bi-star-fill" v-else></i>
                        </button>
                      </div>
                    </div>
                    
                    <!--
                      <div style="margin-top:30px;">
                        <button class="btnBlue fullWidth center">
                          <i class="bi bi-pencil-square"></i>
                          Registrar Información de Discapacidad
                        </button>
                      </div>
                    -->

                  </div>                                
                
              </div>

              <div class="col50 colSmMin100 row rowm" style="margin-left: 0%;" v-if="formData.nivelSatisfaccion.data!=0">

                  <strong class="formLabel " >
                    Sugerencia:
                  </strong>
                  

                  <div class="tLeft fullWidth">

                    <div>
                      <div class="col95 row colSmMin95">
                        ¿Tienes alguna sugerencia o comentario que nos ayude a mejorar?
                      </div>

                      <div class="col75 row colSmMin100">
                        <button :class="(showSugerencia?'btnBlue':'btnDefault')+' col50 row'" @click="showSugerencia=true;formData.sugerencia.data=='NINGUNA'?formData.sugerencia.data='':'';">
                          Si
                        </button>
                        <button :class="(!showSugerencia?'btnBlue':'btnDefault')+' col50 row'" @click="showSugerencia=false;formData.sugerencia.data = 'NINGUNA';">
                          No
                        </button>
                      </div>
                    </div>

                    <div v-if="showSugerencia">                      
                      <small>
                        Caracteres: 
                        <strong>
                          {{formData.sugerencia.data.length}}/120
                        </strong>
                      </small>
                      <input-text-area class="col75 row colSm100" ref="sugerenciaRef" :placeholder="'Comentario o Sugerencia'" :propName="'sugerencia'" :whiteBackground="false" :mode="'AN'" 
                      :capital="true" :maxLength="120" :minLength="5"></input-text-area>
                    </div>
                    
                    <!--
                      <div style="margin-top:30px;">
                        <button class="btnBlue fullWidth center">
                          <i class="bi bi-pencil-square"></i>
                          Registrar Información de Antecedentes Quirurgicos
                        </button>
                      </div>
                      -->

                  </div>

              </div>

              <div class="col50 colSm95 row hideMobile" style="background:none;">
                <div class="formRow colSm95">
                  <span></span>                                              
                </div>
              </div>

              <button class="btnBlue fullWidth center" style="margin-top:15px;" v-if="isRegistroCompleted()" @click="sendRegistrarEncuesta()">
                <i class="bi bi-pencil-square"></i>
                Registrar Encuesta
              </button>

              <div class="col50 colSm95 row" style="background:none;">
                <div class="formRow colSm95">
                  <span></span>                                              
                </div>
              </div>

            </section>

          </div>
    
      </div>

    </div>
    
  </div>

  <modal title="Registro Encuesta del Alumno" v-if="showModal" v-on:closeModalEv="closeModal()" style="display:block;left:2.5vw;top:5vh;height:30vh;width:95vw;">
    <div style="text-align:center;overflow-y:auto;">
      <h3 style="color:black;">
        {{modalMessage}}
      </h3>
    </div>
    <div>
      <button class="btnBlue" @click="closeModal()">
        Aceptar y Continuar        
      </button>
    </div>
  </modal>


</template>

<script>

import { mapStores } from 'pinia';
import { useUserStore } from '../../../store/user';
//import InputText from '../../Inputs/InputText.vue';
//import InputPassword from '../Inputs/InputPassword.vue';

import Modal from '../../Modal/Modal.vue';
import InputSelectList from '../../Inputs/InputSelectList.vue';
import InputTextArea from '../../Inputs/InputTextArea.vue';


export default {
  name: 'RegistroDatos',
  components:{
    Modal,
    //InputText,    
    InputSelectList,
    InputTextArea,
    //InputPassword
  },
  mounted:function(){
    
    //this.getListaEnfermedadesCronicasAlumno();
    this.getListaCatalogoFinalidades();


  },
  data:function(){
    return{

      modo:'ENFERMEDAD',
      
      showNuevoRegistro:false,
      registroExitoso:false,
      

      showSugerencia:false,
      showModal:false,
      modalMessage:'',
      procesando:0,
      informacionEnviada:false,

      listaCatalogoFinalidades:[],
      listaCatalogoTipoNegocio:[],

      

      showNStars:0,

      formData:{
        'finalidad':{data:"",state:0,key:0},
        'tipoNegocio':{data:"",state:0,key:0},
        'satisfecho':{data:"",state:0},key:0,
        'nivelSatisfaccion':{data:0,state:0,key:0},
        'sugerencia':{data:"NINGUNA",state:0,key:0},
      },
    };    
  },

  props:{

    cursoData:Object

  },
  watch:{

    'formData.finalidad.data':function(){
      if(this.formData.finalidad.data=='MEJORAR NEGOCIO PROPIO'){
        this.getListaCatalogoTipoNegocio();
      }
    }

  },

  methods:{

    displayStars(val){

      this.showNStars=val;

    },

    sendRegistrarEncuesta(){
      console.log("sendRegistrarEncuesta()");

      console.log("this.formData.tipoNegocio.data:"+this.formData.tipoNegocio.data);
      console.log("this.formData.tipoNegocio.data=='MEJORAR NEGOCIO PROPIO':"+(this.formData.tipoNegocio.data=='MEJORAR NEGOCIO PROPIO'));
      

      let tipoNegocio = "";

      if(this.formData.finalidad.data=='MEJORAR NEGOCIO PROPIO'){
        tipoNegocio = this.formData.tipoNegocio.data;
      }else{
        tipoNegocio = "-";
      }

      let data = {
        id:''+this.cursoData.c0,
        finalidad:''+this.formData.finalidad.data,
        tipoNegocio:''+tipoNegocio,
        satisfaccion:''+this.formData.satisfecho.data,
        nivelSatisfaccion:''+this.formData.nivelSatisfaccion.data,
        sugerencia:''+this.formData.sugerencia.data
      };
      console.log("data: ");
      console.log(data);
      this.$root.sendPOSTRequest(
        "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/newRegistroEncuesta/",
        data,
        this.onSuccessSendRegistrarEncuesta
      );
    },
    onSuccessSendRegistrarEncuesta(data){
      console.log("onSuccessSendRegistrarEncuesta:");
      console.log(data);

      if(data.updateEstadoInscripcion=='ok'){

        this.showModal=true;
        this.modalMessage="Registro de Encuesta Exitoso";
        this.registroExitoso = true;

        this.$emit('updateEstadoEncuestaEv',true);

      }else{

        this.showModal=true;
        

        if(data.updateEstadoInscripcion=='UNSET'){

          this.modalMessage="Error: Encuesta ya registrada previamente";

        }else{
          this.modalMessage="Error al registrar su encuesta";
          console.log("ERROR: ");
          console.log(data);
        }        

      }


    },
    
    getListaCatalogoFinalidades(){
      console.log("getListaCatalogoFinalidades()");

      let data = {        
      };
      console.log("data: ");
      console.log(data);
      this.$root.sendPOSTRequest(
        "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/getListaCatalogoFinalidades/",
        data,
        this.onSuccessGetListaCatalogoFinalidades
      );
    },
    onSuccessGetListaCatalogoFinalidades(data){

      console.log("onSuccessGetListaCatalogoFinalidades:");
      console.log(data);
      this.setListaCatalogoFinalidades(data.data.data);

    },
    setListaCatalogoFinalidades(data){
      this.listaCatalogoFinalidades = data;
    },

    getListaCatalogoTipoNegocio(){
      console.log("getListaCatalogoTipoNegocio()");

      let data = {        
      };
      console.log("data: ");
      console.log(data);
      this.$root.sendPOSTRequest(
        "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/getListaCatalogoTipoNegocio/",
        data,
        this.onSuccessGetListaCatalogoTipoNegocio
      );
    },
    onSuccessGetListaCatalogoTipoNegocio(data){

      console.log("onSuccessGetListaCatalogoTipoNegocio:");
      console.log(data);
      this.setListaCatalogoTipoNegocio(data.data.data);

    },
    setListaCatalogoTipoNegocio(data){
      this.listaCatalogoTipoNegocio = data;
    },
    
    
    sendClose(){

      this.$emit('closeAccionEv');

    },

    isRegistroCompleted(){

      return (
        (this.formData.finalidad.state==1?
          (
            this.formData.finalidad.data=='MEJORAR NEGOCIO PROPIO'?
            this.formData.tipoNegocio.state==1:
            this.formData.finalidad.state==1
          ):false
        )&&
        this.formData.satisfecho.state==1&&
        this.formData.nivelSatisfaccion.state==1&&
        (this.showSugerencia?this.formData.sugerencia.state==1:true)
      );

    },

    closeAccion(){

      this.$emit('closeAccionEv');

    },

    closeModal(){
      this.showModal = false;
      
      if(this.registroExitoso){

        this.closeAccion();

      }

    },

  },
  computed:{
    ...mapStores(useUserStore),
    
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.btnStar{

  color:var(--orange);

  background:none;
  font-family: fedrasanslight;
  border-radius: 5px;
  border:none;
  line-height: 32px;
  cursor: pointer;
  

}

.btnStar:hover{

  color:var(--blueDark);

}




.glassModulo{
    
    z-index:100;  
    
    background: rgba(255,255,255,0.30);    
    backdrop-filter: blur(2px);
    box-shadow: 0 10px 32px 0 rgba(31,38,135,0.37);    
    margin: 0 auto;
    margin-bottom: 0px;
    border-radius: 10px;
    padding:5px;
    border: 1px solid rgba(255,255,255,0.18);
    
  }

</style>
